// Localized brand assets — mirrors RN `apps/WunderGuide/utils/localizedAsset.ts`
// 1:1, including the asset filenames and the per-language switch on the bare
// language code (so both `zh-Hans` and `zh-Hant` map to the same `zh` variant,
// just like the RN bundle).
//
// `Logo`     = full mark (sparkle + logotype). Used in the Profile/Account
//              footer to match the RN app's SettingsDrawer footer.
// `LogoType` = wordmark only. Used on Dashboard / nav.

const Logo_default = '/brand/_default/WunderGuide-logo-r.svg';
const Logo_ja = '/brand/ja/WunderGuide-logo-white-ja.svg';
const Logo_ko = '/brand/ko/WunderGuide-logo-white-ko.svg';
const Logo_zh = '/brand/zh/WunderGuide-logo-white-zh.svg';

const LogoType_default = '/brand/_default/WunderGuide-logotype-white.svg';
const LogoType_ja = '/brand/ja/WunderGuide-logotype-white-ja.svg';
const LogoType_ko = '/brand/ko/WunderGuide-logotype-white-ko.svg';
const LogoType_zh = '/brand/zh/WunderGuide-logotype-white-zh.svg';

function resolveLogoUrl(language: string): string {
  const lang = language.split('-')[0];
  switch (lang) {
    case 'ja':
      return Logo_ja;
    case 'ko':
      return Logo_ko;
    case 'zh':
      return Logo_zh;
    default:
      return Logo_default;
  }
}

function resolveLogoTypeUrl(language: string): string {
  const lang = language.split('-')[0];
  switch (lang) {
    case 'ja':
      return LogoType_ja;
    case 'ko':
      return LogoType_ko;
    case 'zh':
      return LogoType_zh;
    default:
      return LogoType_default;
  }
}

interface LogoProps {
  style?: React.CSSProperties;
  className?: string;
  /** Ignored; parity with RN SVG component which forwards `fill`. */
  fill?: string;
}

const makeLogo =
  (language: string): React.FC<LogoProps> =>
  ({ style, className, fill: _fill }) => (
    <img
      src={resolveLogoUrl(language)}
      alt="WunderGuide"
      className={className}
      style={{ height: '100%', width: 'auto', ...style }}
    />
  );

const makeLogoType =
  (language: string): React.FC<LogoProps> =>
  ({ style, className, fill: _fill }) => (
    <img
      src={resolveLogoTypeUrl(language)}
      alt="WunderGuide"
      className={className}
      style={{ height: '20px', width: 'auto', ...style }}
    />
  );

const DefaultPoweredByLogo: React.FC = () => (
  <div
    style={{
      width: '100%',
      height: '100%',
      background: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: '12px',
    }}
  >
    Powered by AI
  </div>
);

export const getLogo = (language: string) => makeLogo(language);

export const getLogoType = (language: string) => makeLogoType(language);

export const getPoweredByLogo = (_language: string) => DefaultPoweredByLogo;
